import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { color } from '../../../../app/theme';
import TextField from '../../../shared/TextField';

const useStyles = makeStyles(
  {
    root: {
      borderRadius: 24,
      backgroundColor: '#F9F9F9',
      padding: '12px 16px',
      color: color.$13,
      fontSize: '15px',
      lineHeight: '15px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& > div': {
        whiteSpace: 'nowrap',
      },
    },
  },
  {
    name: 'TotalOrderCount',
  },
);

const TotalOrderCount = ({ conditions, onChange, isError }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div>{t('ec.totalOrderCountConditions1')}</div>
      <TextField
        type="text"
        isValid
        placeholder={t('trigger-setting.keywords-placeholder')}
        value={conditions || 0}
        onChange={event => {
          const { value } = event.target;
          const parsedValue = parseInt(value, 10);
          if (!Number.isNaN(parsedValue) && parsedValue >= 0) {
            onChange(parsedValue);
          }
        }}
        isError={isError && !conditions}
      />
      <div>{t('ec.totalOrderCountConditions2')}</div>
    </div>
  );
};

export default TotalOrderCount;
